let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bVhr1")).then(() => parcelRequire('b4yf3'));